import { MST1030_R01Dto } from "./Dto_MST1030_R01";
import { getData } from "src/utils/axios/serverHelper";
import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { MST1030_R01Filter } from "./Store_MST1030_R01";

const baseUrl = `${config.apiUrl}/MST1030_R01`;

export type TreeDirection = 'forward' | 'reverse';

export const getBomTree = async (
    params: Partial<MST1030_R01Filter>,
    treeDirection: TreeDirection = 'forward'
) => {
    return await getData<ResponseDto<MST1030_R01Dto[]>>(baseUrl, {
        params: {
            searchText: params?.searchText,
            itemGroup: params?.itemGroup,
            itemAccount: params?.itemAccount,
            treeDirection,
        },
    });
};

export const exportBomExcel = async (
    params: Partial<MST1030_R01Filter>,
    treeDirection: TreeDirection = 'forward'
) => {
    const url = `${baseUrl}/excel/`;
    return await getData<ResponseDto<string>>(url, {
        params: {
            searchText: params?.searchText,
            itemGroup: params?.itemGroup,
            itemAccount: params?.itemAccount,
            treeDirection,
        },
    });
};
